import { Shape as c } from "three";
function a(e) {
  const t = new c();
  if (!e.length)
    return t;
  const r = 0, h = e[0].length === 2 ? 1 : 2;
  t.moveTo(e[0][r], e[0][h]);
  for (let n = 1; n < e.length; n++)
    t.lineTo(e[n][r], e[n][h]);
  return t.closePath(), t;
}
export {
  a as createShape
};
//# sourceMappingURL=index4.js.map
